import IconSearch from '~/assets/aside-icons/search.png';
import IconMain from '~/assets/aside-icons/main.png';
import IconWatch from '~/assets/aside-icons/watch.png';
import IconFilms from '~/assets/aside-icons/films.png';
import IconFavorites from '~/assets/aside-icons/favorites.png';
import IconHistory from '~/assets/aside-icons/history.png';
import IconStar from '~/assets/aside-icons/star.png';

export interface NavigationItem {
    title: string | object;
    link: string;
    icon: any;
    childCheck: boolean;
    event?: () => void;
    confirmBeforeEvent?: boolean;
}

export const navigationItems: NavigationItem[] = [
    {
        title: 'Поиск',
        link: '/search',
        icon: IconSearch,
        childCheck: false
    },
    {
        title: 'Главная',
        link: '/',
        icon: IconMain,
        childCheck: false
    },
    {
        title: 'Продолжить просмотр',
        link: '/browsing',
        icon: IconWatch,
        childCheck: false
    },
    {
        title: 'Кинотеатр VOD',
        link: '/cinema',
        icon: IconFilms,
        childCheck: true
    },
    {
        title: 'Избранное',
        link: '/favorite',
        icon: IconFavorites,
        childCheck: false
    },
    {
        title: 'История просмотров',
        link: '/history',
        icon: IconHistory,
        childCheck: true
    },
    {
        title: 'Вернуться к Cellcom tv+',
        link: '#',
        icon: IconStar,
        childCheck: false,
        confirmBeforeEvent: true,
        // @ts-ignore
        event: () => window.application?.close() || useLogger('NOT_FOUND_CLOSE_APP_ACTION')
    }
];
